import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getDecryptDataFromLocal } from "../../../utils/encrypt";
import { DELIVERY_CENTER_EXTERNAL_USERS } from "./deliveryCenterExternalAccess";

const ALLOWED_PATH = "/bulk/delivery-center-orders";

// Restricts the two Shipshopy external users (see deliveryCenterExternalAccess.js) to only the
// Delivery Center Orders page across the whole CRM. The sidebar already only offers this one
// item (see menu-items/index.js) — this catches direct URL typing, the back button, or a stale
// tab landing anywhere else. Silently redirects — no interstitial message, per Shailendra
// 2026-09-02 ("dont show anything...redirect to the at delivery center tab").
function ExternalUserRouteGuard() {
  const phoneNumber = getDecryptDataFromLocal("phoneNumber");
  const isExternalUser = DELIVERY_CENTER_EXTERNAL_USERS.includes(phoneNumber);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (isExternalUser && location.pathname !== ALLOWED_PATH) {
      history.replace(ALLOWED_PATH);
    }
  }, [isExternalUser, location.pathname, history]);

  return null;
}

export default ExternalUserRouteGuard;
